import { RouterProvider } from 'react-router-dom';

import { NotificationContainer } from '@webclient/components/notification';

import Providers from '@webclient/providers/index';

import 'react-toastify/dist/ReactToastify.css';

import CookiesNotice from '@webclient/layouts/components/cookies-notice';
import router from '@webclient/router/index';

export function App() {
  return (
    <Providers>
      <NotificationContainer />
      <CookiesNotice />
      <RouterProvider
        future={{
          v7_startTransition: true,
        }}
        router={router}
      />
    </Providers>
  );
}

export default App;
